import ChartContainer from "./ChartContainer";
import React, {useEffect, useState} from "react";
import DownloadButton from "components/buttons/DownloadButton";
import HighchartsReact from "highcharts-react-official";
import {useSelector} from "react-redux";
import {Select} from "antd";
import PortfolioHistogram from "../HighCharts/PortfolioHistogram";
import { useLazyGetPortfolioLobsQuery} from "../../../redux/api/chartsApiSlice";
import {selectUser} from "../../../redux/features/userSlice";

export default function LobPortfolioChart(props: { chartRef: React.RefObject<HighchartsReact.RefObject>, className: string }) {

    const title = 'Portafoglio LOB'
    const [lobs, setLobs] = useState<string[]>([])
    const [series, setSeries] = useState<number[]>([])
    const [getData, {isLoading, isFetching, isError, data}] = useLazyGetPortfolioLobsQuery()
    const description = 'Il grafico mostra la suddivisione delle polizze per LOB.'

    const select = <Select key={'select'} options={[{label: 'Da caricare delega ISIA', value: 0}]} defaultValue={0}
                           bordered={false}
                           style={{backgroundColor: '#F9FBFF', color: '#7E7E7E', padding: '0.6rem 0.8rem',}}/>

    const budgetGroup = useSelector(selectUser).preferences?.charts_params?.budget_group
    const uwYear = useSelector(selectUser).preferences?.charts_params?.uw_year
    const isia = useSelector(selectUser).preferences?.charts_params?.isia

    useEffect(() => {
        if (budgetGroup && typeof uwYear === 'number' && isia) {
            getData({
                uw_year: uwYear,
                budget_group: budgetGroup.value,
                isia: isia.value,
                upload_reason: ''
            })
        }
    }, [budgetGroup, getData, isia, uwYear])

    useEffect(() => {
        if (data) {
            setLobs(data.map((itm) => itm.name))
            setSeries(data.map((itm) => {
                return itm.negotiations
            }))
        }
    }, [data])

    return <ChartContainer
        description={description}
        loading={isLoading || isFetching}
        className={props.className}
        title={title}
        buttons={[select, <DownloadButton key={'download-button'} chartRef={props.chartRef}/>]}
    >
        <PortfolioHistogram
            chartRef={props.chartRef}
            options={{
                xAxis: {
                    type: "category",
                    categories: lobs.map(el => el),
                    visible: true,
                    lineWidth: 0
                },
                series: [{
                    color: '#EA3232',
                    type: 'column',
                    data: lobs.map((el, index) => ({name: el, y: series[index]})),
                }],
                exporting: {
                    chartOptions: {
                        title: {
                            text: title
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true
                                }
                            }
                        }
                    }
                }
            }}
        />
    </ChartContainer>
}